export default {
  functional: true,
  props: {
    vNode: [Array, String, Object, Number],
    customStyle: {
      type: [String, Object],
      default: () => {}
    }
  },
  render(h, ctx) {
    const vNode = ctx.props.vNode
    vNode.data.style = {
      ...vNode.data.style,
      ...ctx.props.customStyle
    }
    return vNode
  }
}
